<template>
  <div>
    <AddDocumentDialog v-model="showAddDialog" />
    <AskDialog v-model="showAskDeleteDialog" @ok="delDoc(curDoc)" />
    <v-btn v-if="$store.getters['auth/isAllowed']('candidate_dossier_add')" @click="showAddDialog = true" class="mb-4" color="primary">
      Добавить документ
    </v-btn>
    <v-data-table
      :headers="headers"
      :items="items"
      sort-by="id"
      sort-desc
      :loading="loading.load"
      loading-text="Загрузка... Пожалуйста подождите"
      :mobile-breakpoint="300"
      :page="filter.page"
      :items-per-page="filter.pageSize"
      :height="tableHeight"
      fixed-header
      dense
      @pagination="pagination"
      hide-default-footer
      :server-items-length="count"
      :_footer-props="{ itemsPerPageOptions: [25] }"
    >
      <!-- Header -->
      <template v-slot:header>
        <tr>
          <!-- <td class="border-bottom pa-4">
            <div>
              <v-checkbox :input-value="selected.length" @change="onChangeAllCheck"
                :indeterminate="!!selected.length && selected.length !== count" hide-details class="mt-auto" dense
              />
            </div>
          </td> -->

          <td class="border-bottom pa-3">
            <div>
              <v-text-field
                label="Название" append-icon="mdi-magnify" class="font-sm" :value="filter.name"
                @input="debouncedSetFilterName" dense hide-details outlined
              />
            </div>
          </td>

          <td class="border-bottom pa-3">
            <div class="other-width-col">
              <v-menu offset-y :close-on-content-click="false" ref="menu">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn elevation="0" class="font-weight-regular" v-bind="attrs" v-on="on" outlined color="grey darken-1">
                    Выберите тип {{selectedDocTypes.length ? `(${selectedDocTypes.split(',').length})` : ''}}
                    <v-icon v-if="attrs['aria-expanded']">mdi-menu-down</v-icon>
                    <v-icon v-else>mdi-menu-up</v-icon>
                  </v-btn>
                </template>
                <ListDocTypes v-model="selectedDocTypes" :items="docTypes" :loading="loading.load" @apply="loadItems">
                </ListDocTypes>
              </v-menu>
            </div>
          </td>

          <td class="border-bottom pa-3">
            <v-menu v-model="datePickerShow" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="filterUploadDate.join(' - ')"
                  label="Дата загрузки"
                  append-icon="mdi-calendar"
                  :prepend-inner-icon="filterUploadDate.length ? 'mdi-close' : null"
                  @click:prepend-inner="clearFilterUploadDate"
                  class="font-sm"
                  dense readonly outlined hide-details
                  v-bind="attrs" v-on="on"
                />
              </template>

              <v-date-picker v-model="filterUploadDate" dense range no-title scrollable locale="ru-RU">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="cancelFilterUploadDate"> Отменить </v-btn>
                <v-btn text color="primary" @click="applyFilterUploadDate" :disabled="filterUploadDate.length !== 2"> OK </v-btn>
              </v-date-picker>
            </v-menu>
          </td>

          <td class="border-bottom pa-3">
            <div class="other-width-col">
              <v-menu offset-y :close-on-content-click="false" ref="menu">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn elevation="0" class="font-weight-regular" v-bind="attrs" v-on="on" outlined color="grey darken-1">
                    Выберите источник {{selectedDocSources.length ? `(${selectedDocSources.split(',').length})` : ''}}
                    <v-icon v-if="attrs['aria-expanded']">mdi-menu-down</v-icon>
                    <v-icon v-else>mdi-menu-up</v-icon>
                  </v-btn>
                </template>
                <ListDocTypes v-model="selectedDocSources" :items="docSources" :loading="loading.load" @apply="loadItems">
                </ListDocTypes>
              </v-menu>
            </div>
          </td>

          <td class="border-bottom pa-3">
            <div>
              <v-text-field label="Комментарий" append-icon="mdi-magnify" class="font-sm" dense :value="filter.comment"
                @input="debouncedSetFilterComment" hide-details outlined
              />
            </div>
          </td>
        </tr>
      </template>

      <!--  Cells  -->
      <!-- <template v-slot:item.check="{ item }">
        <div>
          <v-checkbox :input-value="selected.some(id => id === item.id)" @change="setSelected(item.id)" hide-details class="mt-auto" />
        </div>
      </template> -->

      <template v-slot:item.name="{ item }">
        <div class="d-flex justify-space-between align-center cursor-pointer" @click="downloadDoc(item)">
          {{ item.name }}
        </div>
      </template>

      <template v-slot:item.type="{ item }">
        <div>{{ getDocType(item) }}</div>
      </template>

      <template v-slot:item.upload_date="{ item }">
        <div class="d-flex justify-space-between align-center">
          <!-- {{ $moment(item.upload_date).format('DD.MM.YYYY') }} -->
          {{ item.upload_date }}
        </div>
      </template>

      <template v-slot:item.source="{ item }">
        <div>{{ getDocSource(item) }}</div>
      </template>

      <template v-slot:item.comment="{ item }">
        <div class="py-2 _pa-2 _other-width-col">
          <v-tooltip v-if="item.comment" top>
            <template v-slot:activator="{ on, attrs }">
              <div class="d-flex" v-bind="attrs" v-on="on">
                <v-text-field label="Комментарий" class="font-xs" dense :value="item.comment" @input="debouncedSendComment($event, item)" hide-details outlined />
              </div>
            </template>
            <span>{{ item.comment }}</span>
          </v-tooltip>
          <v-text-field v-else label="Комментарий" class="font-xs" dense :value="item.comment" @input="debouncedSendComment($event, item)" hide-details outlined />
        </div>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn v-if="$store.getters['auth/isAllowed']('candidate_dossier_delete')"
          @click="deleteCandidateDialog(item)" class="" dense icon
          :loading="loading.del===item.id"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>

      <template v-slot:no-data> Документов не найдено. </template>

      <template v-slot:footer="{ props }">
        <v-data-footer
          :pagination="props.pagination"
          :options="props.options"
          @update:options="updateOptions"
          items-per-page-text="Документов на странице:"
          :items-per-page-options="[10, 20, 50, 100, 500, 1000]"
          :page-text="`Всего документов: ${props.pagination.itemsLength}. Страница ${props.options.page} из ${props.pagination.pageCount}`"
          show-current-page
          show-first-last-page
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from 'vuex';
import { debounce } from 'lodash';
import { DOC_TYPES_TITLES, DOC_TYPES, DOC_SOURCES_TITLES, DOC_SOURCES } from '@/common/constants/docTypes';
import AddDocumentDialog from './AddDocumentDialog';
import ListDocTypes from './ListDocTypes';
import AskDialog from "@/components/ui/AskDialog"

export default {
  name: 'CandidatesTable',
  components: {
    AddDocumentDialog, ListDocTypes, AskDialog
  },
  data: () => ({
    showAddDialog: false,
    showAskDeleteDialog: false,
    tableHeight: 400,
    docTypes: Object.entries(DOC_TYPES_TITLES).map(s => ({
      text: s[1],
      value: DOC_TYPES[s[0]]
    })),
    docSources: Object.entries(DOC_SOURCES_TITLES).map(s => ({
      text: s[1],
      value: DOC_SOURCES[s[0]]
    })),
    headers: [
      // { text: '', value: 'check', sortable: false, width: '40px' },
      { text: 'Название', value: 'name', sortable: false },
      { text: 'Тип', value: 'type', sortable: false, width: '220px' },
      { text: 'Дата загрузки', value: 'upload_date', sortable: false, width: '190px' },
      { text: 'Источник загрузки', value: 'source', sortable: false, width: '230px', },
      { value: 'comment', sortable: false, width: '200px', text: 'Комментарий', },
      { text: '', value: 'actions', sortable: false, align: 'end', }
    ],
    paginationData: null,
    datePickerShow: false,
    filterUploadDate: [],
    datePickerDateFormat: 'DD-MM-YYYY',
    curDoc: 0,
  }),
  computed: {
    ...mapGetters({
      loading: 'users/dossiers/loading',
      items: 'users/dossiers/items',
      selected: 'users/dossiers/selected',
      filter: 'users/dossiers/filter',
      count: 'users/dossiers/count',
    }),
    selectedDocTypes: {
      get() {
        return this.filter.type;
      },
      set(val) {
        this.setFilterType(val);
      }
    },
    selectedDocSources: {
      get() {
        return this.filter.source;
      },
      set(val) {
        this.setFilterSource(val);
      }
    },
  },
  methods: {
    ...mapActions({
      setSelected: 'users/dossiers/setSelected',
      allSelected: 'users/dossiers/allSelected',
      clearSelected: 'users/dossiers/clearSelected',
      setFilterPage: 'users/dossiers/setFilterPage',
      setFilterPageSize: 'users/dossiers/setFilterPageSize',
      setFilterName: 'users/dossiers/setFilterName',
      setFilterUploadDate: 'users/dossiers/setFilterUploadDate',
      setFilterComment: 'users/dossiers/setFilterComment',
      setFilterType: 'users/dossiers/setFilterType',
      setFilterSource: 'users/dossiers/setFilterSource',
      setFilterAll: 'users/dossiers/setFilterAll',
      loadItems: 'users/dossiers/loadItems',
      delDocument: 'users/dossiers/delDocument',
      editDossierComment: 'users/dossiers/editDossierComment',
      downloadDocument: 'users/dossiers/downloadDocument',
    }),
    updateOptions(param) {
      this.setFilterPageSize({ page: param.page, pageSize: param.itemsPerPage });
    },
    initialize() {
      this.setFilterAll({ candidateId: this.$route.params.id, params: this.$route.query });
    },
    pagination(data) {
      this.paginationData = data;
    },
    onChangeAllCheck(bool) {
      if (bool) {
        this.allSelected();
      } else {
        this.clearSelected();
      }
    },
    // eslint-disable-next-line func-names
    debouncedSetFilterName: debounce(function (val) {
      this.setFilterName(val);
    }, 500),
    // eslint-disable-next-line func-names
    debouncedSetFilterComment: debounce(function (val) {
      this.setFilterComment(val);
    }, 500),
    debouncedSendComment: debounce(function (text, item) {
      this.editDossierComment({
        id: item.id,
        text
      });
    }, 1000),
    getDocType(item) {
      const key = Object.keys(DOC_TYPES).find(k => DOC_TYPES[k] === item.type);
      return key ? DOC_TYPES_TITLES[key] : 'Не найдено';
    },
    getDocSource(item) {
      const key = Object.keys(DOC_SOURCES).find(k => DOC_SOURCES[k] === item.source);
      return key ? DOC_SOURCES_TITLES[key] : 'Не найдено';
    },
    clearFilterUploadDate() {
      this.filterUploadDate = [];
      this.setFilterUploadDate(this.filterUploadDate);
      this.datePickerShow = false;
    },
    cancelFilterUploadDate() {
      if (this.filter.upload_date_from && this.filter.upload_date_to) {
        this.filterUploadDate = [this.filter.upload_date_from, this.filter.upload_date_to];
      } else {
        this.filterUploadDate = [];
      }
      this.datePickerShow = false;
    },
    applyFilterUploadDate() {
      this.filterUploadDate = this.filterUploadDate.sort((a, b) =>
        this.$moment(a, this.datePickerDateFormat).isBefore(this.$moment(b, this.datePickerDateFormat)) ? -1 : 1
      );
      this.setFilterUploadDate(this.filterUploadDate);
      this.datePickerShow = false;
    },
    deleteCandidateDialog(item) {
      this.curDoc = item;
      this.showAskDeleteDialog = true;
    },
    async delDoc(item) {
      await this.delDocument(item.id)
    },

    async downloadDoc(item) {
      const response = await this.downloadDocument(item.id)
      if (!response || !response.blob) {
        this.$toast.error('Не удалось загрузить документ', '', { position: 'topRight' });
        return
      }

      const downloadUrl = window.URL.createObjectURL(response.blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', response.filename); 
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    }  
  },
  watch: {
    filter: {
      handler(val) {
        const query = {};
        for (const [key, value] of Object.entries(val)) {
          if (Array.isArray(value) && value.length) {
            query[key] = value.join(',');
          } else if (value || value === 0) {
            query[key] = value;
          }
        }
        this.$router
          .replace({ name: this.$route.name, query })
          .catch(() => {});
      },
      deep: true
    },
  },
  created() {
    this.initialize();
  },
  mounted() {
    const height = document.documentElement.clientHeight - 420;
    this.tableHeight = Math.max(height, this.tableHeight);
  }
};
</script>

<style lang="scss">
.v-list.v-sheet {
  padding: 0 !important;
}
.v-list-item__content {
  padding: 0 !important;
}
.v-list-item__action {
  margin-top: 0;
  margin-bottom: 0;
}
.v-select__selections {
  flex-wrap: nowrap;
}
.other-width-col {
  width: 14rem;
}
</style>
